import { FC } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";

import { Tag as AntdTag, TagProps } from "antd";

type ModifiedTagProps = Partial<TagProps> & {
  className?: string;
  size?: "small" | "middle" | "large";
  type?: "colored" | "primary" | "secondary" | "surface";
  hoverable?: boolean;
  rounded?: boolean;
};

export const Tag: FC<ModifiedTagProps> = ({
  className,
  children,
  rounded = true,
  size = "middle",
  type = "colored",
  hoverable,
  ...props
}) => {
  return (
    <AntdTag
      className={clsx(
        styles.root,
        rounded && styles.rounded,
        hoverable && styles.hoverable,
        styles[size],
        styles[type],
        !!props.onClick && styles.clickable,
        className
      )}
      {...props}
    >
      {children}
    </AntdTag>
  );
};
